import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import './App.scss';

import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import HomePage from './pages/HomePage/HomePage.js';
import AboutUs from './pages/AboutUs/AboutUs';
import Values from './pages/AboutUs/Values';
import Team from './pages/AboutUs/Team';
import ContactUs from './pages/ContactUs/ContactUs.js';
import NowHiring from './pages/NowHiring/NowHiring';
import Feedback from './pages/Feedback/Feedback.js';
import AYHASponsor from './pages/Sponsors/AYHA/AYHASponsor';
import Scholarship from './pages/Scholarship/Scholarship'

import Enrichment from './pages/Enrichment/General/Enrichment';

import LotusSpringTwo from './pages/Enrichment/Lotus/LotusSpringTwo'
import BasketballLeague from './pages/Leagues/ThreeVThree';
import Training from './pages/Training/BasketballTraining';


import CampsAndClinics from './pages/CampsAndClinics/CampsAndClinics';
import WeekCamps from './pages/CampsAndClinics/WeekCamps';
import Holiday from './pages/CampsAndClinics/Holiday';
import Peewee from './pages/CampsAndClinics/Peewee';


import TurkeyPickleballTourney from './pages/Pickleball/TurkeyTournament';

class App extends Component {
  
  render() {
    return (
      <BrowserRouter>
        <div className="background">
            <Header />
            <Route exact path="/" component={HomePage} />
            <Route path="/About" component={AboutUs} />
            <Route path="/Values" component={Values} />
            <Route path="/Team" component={Team} />
            <Route path="/Enrichment" component={Enrichment} />
            <Route path="/CampsAndClinics" component={CampsAndClinics} />


            <Route path="/TurkeyTournament" component={TurkeyPickleballTourney} />
            <Route path="/BasketballLeague" component={BasketballLeague}/>
            <Route path="/BasketballOpenHouse" component={Training}/>




            <Route path="/606atLotus" component={LotusSpringTwo}/>

      

            <Route path="/Peewee" component={Peewee} />
            <Route path="/Holiday" component={Holiday} />
            <Route path="/WeekCamps" component={WeekCamps} />

            <Route path="/Scholarship" component={Scholarship} />
            <Route path="/Sponsor" component={AYHASponsor} />
            <Route path="/Employment" component={NowHiring} />
            <Route path="/ContactUs" component={ContactUs} />
            <Route path="/Feedback" component={Feedback} />
            
        </div>
        <Footer />

      </BrowserRouter>
    );
  }
}

export default App;